import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
// services
import {OrganizationService} from '../../service/organization.service';
import {MessagingService} from '../../service/messaging.service';

@Component({
  selector: 'app-organisation-form',
  templateUrl: './organisation-form.component.html',
  styleUrls: ['./organisation-form.component.scss']
})
export class OrganisationFormComponent implements OnInit, OnDestroy {

  private org;
  public checkedBoxes;
  public titleObserver;
  public checkboxObserver;
  public modalTitle;
  public retrievingData = true;
  public selectedContract;
  public updatableOrg;
  public updateOrg = {title: null, revocationEmail: null};
  public searchTerm;
  public allSelect = false;
  public formSubmitted = false;

  // reactive form
  organizationForm: FormGroup;

  constructor(private _organizationService: OrganizationService,
              public activeModal: NgbActiveModal,
              public msgService: MessagingService) {
  }

  ngOnInit() {

    this.titleObserver = this.msgService.modalTitleSubject
      .subscribe((result) => {
        this.modalTitle = result;
      });

    // populate checkboxes
    this.checkboxObserver = this._organizationService.updatableOrgSubject
      .subscribe((val) => {
        if (val !== null && val !== undefined) {
          this.updatableOrg = val;
          this.updateOrg.title = val.title
          this.updateOrg.revocationEmail = val.revocationEmail;
          // set checked boxes
          this.checkedBoxes = val.contracts;
        } else {
          this.updateOrg.title = null;
        }
      });

    this.organizationForm = new FormGroup({
      'organization_title': new FormControl(this.updateOrg.title, Validators.required),
      'revocation_email': new FormControl(this.updateOrg.revocationEmail, [Validators.email, Validators.required]),
      'organization_contracts': new FormArray([])
    });

    this._organizationService.getContracts()
      .subscribe((result) => {
        result.forEach(obj => {
          const control = new FormControl(obj, Validators.required);
          (<FormArray>this.organizationForm.get('organization_contracts')).push(control);
        });
        if (this.checkedBoxes !== null && this.checkedBoxes !== undefined) {
          for (let i = 0; this.organizationForm.get('organization_contracts').value.length > i; i += 1) {
            for (let x = 0; this.checkedBoxes.length > x; x += 1) {
              if (this.checkedBoxes[x].id === this.organizationForm.get('organization_contracts').value[i].id) {
                this.organizationForm.get('organization_contracts').value[i].checked = true;
                this.selectedContract = true;
              }
            }
          }
          if (this.organizationForm.get('organization_contracts').value.length === this.checkedBoxes.length) {
            this.allSelect = true;
          }
        }
        this.retrievingData = false;
      });
  }

  // append new value to form object
  onCheck(e) {
    let counter = -1;
    this.organizationForm.get('organization_contracts').value.forEach((obj) => {
      counter += 1;
      if (obj.id == e.target.value) {
        obj.checked = e.target.checked;
        this.selectedContract = true;
      }
    });
  }

  search(val: any) {
    this.searchTerm = val.target.value;
  }

  onSelectAll(event) {
    if (this.allSelect === false) {
      this.organizationForm.get('organization_contracts').value.forEach((obj) => {
        obj.checked = true;
      });
      this.allSelect = true;
      this.selectedContract = true;
    } else {
      this.organizationForm.get('organization_contracts').value.forEach((obj) => {
        delete obj['checked'];
      });
      this.allSelect = false;
      this.selectedContract = false;
    }
  }

  onSubmit() {
    this.formSubmitted = true;
    const form = this.organizationForm;
    let orgArray = (<FormArray>this.organizationForm.get('organization_contracts'));
    let countChecks = 0;

    orgArray = orgArray.value.filter(function (elem, index, array) {
      if (orgArray.value[index].checked) {
        countChecks += 1;
        return orgArray.value[index].checked === true;
      }
    });

    this.org = {
      title: form.value.organization_title,
      revocationEmail: form.value.revocation_email,
      contracts: orgArray
    };

    if (countChecks >= 1) {
      this.selectedContract = true;

      // create
      if (this.checkedBoxes === null || this.checkedBoxes === undefined) {
        this._organizationService.createOrganizations(this.org)
          .subscribe((result) => {
            this.activeModal.dismiss('Closed on successful submit');
          }, err => {
            this.formSubmitted = false;
          });
      } else {
        // update
        this._organizationService.updateOrganizations(this.org, this.updatableOrg.id)
          .subscribe((result) => {
            Object.assign(this.updatableOrg, result);
            this.activeModal.dismiss('Closed on successful submit');
          }, err => {
            this.formSubmitted = false;
          });
      }
    } else {
      this.selectedContract = false;
    }
  }

  ngOnDestroy() {
    this.checkboxObserver ? this.checkboxObserver.unsubscribe() : null;
    this.checkedBoxes = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/modal-edit/organisation-form/organisation-form.component.ts